import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutes, blockWebVersionGuard } from '@core';
import { AuthModule, isAuthedGuard } from '@auth';
import { FindGamesModule } from '@find-games';
import { GamesModule } from '@games';
import { HostedGamesModule } from '@hosted-games';
import { ProfileModule } from '@profile';
import { NotificationsModule } from '@notifications';
import { MessagesModule } from '@messages';
import { BlockedVersionPage, UpdateGuard } from '@update';
import {
  BlockedWebViewComponent,
  ConnectionErrorComponent,
  PolicyPrivacyComponent,
  PolicyPrivacyContentComponent
} from '@ui-components';
import { AdminPanelModule } from '@admin-panel';
import { IntroductionModule } from '../../projects/introduction/src/introduction.module';
import { IntroductionGuard } from '@introduction';
import { DashboardModule } from '@dashboard';
import { MyGamesModule } from '@my-games';
import { TeamsModule } from '@teams';
import { RankModule } from '@rank';
import { IntroductionV2Service } from '@introduction/infra';
import { ShouldShowIntroductionQueryHandler } from '@introduction';

const routes: Routes = [
  {
    path: AppRoutes.ROOT,
    redirectTo: AppRoutes.DASHBOARD,
    pathMatch: 'full'
  },
  {
    path: AppRoutes.DASHBOARD,
    loadChildren: () => DashboardModule,
    canActivate: [isAuthedGuard, blockWebVersionGuard, UpdateGuard, IntroductionGuard],
    providers: [IntroductionV2Service, ShouldShowIntroductionQueryHandler]
  },
  {
    path: AppRoutes.AUTH,
    loadChildren: () => AuthModule,
    canActivate: [UpdateGuard]
  },
  {
    path: AppRoutes.GAMES,
    loadChildren: () => GamesModule,
    canActivate: [UpdateGuard]
  },
  {
    path: AppRoutes.FIND_GAMES,
    loadChildren: () => FindGamesModule,
    canActivate: [UpdateGuard]
  },
  {
    path: AppRoutes.HOST,
    loadChildren: () => HostedGamesModule,
    canActivate: [UpdateGuard]
  },
  {
    path: AppRoutes.MY_GAMES,
    loadChildren: () => MyGamesModule,
    canActivate: [isAuthedGuard, blockWebVersionGuard, UpdateGuard]
  },
  {
    path: AppRoutes.PROFILE,
    loadChildren: () => ProfileModule,
    canActivate: [isAuthedGuard, blockWebVersionGuard, UpdateGuard]
  },

  {
    path: AppRoutes.NOTIFICATIONS,
    loadChildren: () => NotificationsModule,
    canActivate: [isAuthedGuard, blockWebVersionGuard, UpdateGuard]
  },
  {
    path: AppRoutes.MESSAGES,
    loadChildren: () => MessagesModule,
    canActivate: [isAuthedGuard, blockWebVersionGuard, UpdateGuard]
  },
  {
    path: AppRoutes.TEAMS,
    loadChildren: () => TeamsModule,
    canActivate: [UpdateGuard]
  },
  {
    path: AppRoutes.RANK,
    loadChildren: () => RankModule,
    canActivate: [isAuthedGuard, blockWebVersionGuard, UpdateGuard]
  },
  {
    path: AppRoutes.BLOCKED_VERSION,
    component: BlockedVersionPage
  },
  {
    path: AppRoutes.POLICY_PRIVACY,
    component: PolicyPrivacyComponent
  },
  {
    path: AppRoutes.POLICY_PRIVACY_CONTENT,
    component: PolicyPrivacyContentComponent
  },
  {
    path: AppRoutes.ADMIN_PANEL,
    loadChildren: () => AdminPanelModule,
    canActivate: [isAuthedGuard, blockWebVersionGuard]
  },
  {
    path: AppRoutes.INTRODUCTION,
    loadChildren: () => IntroductionModule,
    canActivate: [isAuthedGuard, blockWebVersionGuard]
  },
  {
    path: AppRoutes.WEB_BLOCKED,
    component: BlockedWebViewComponent
  },
  {
    path: AppRoutes.CONNECTION_ERROR,
    component: ConnectionErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
